var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddressBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82001C4.18001 2 2.01001 4.17 2.01001 7.81V16.18C2.01001 19.82 4.18001 21.99 7.82001 21.99H16.19C19.83 21.99 22 19.82 22 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5001 8.09V17.25C11.5001 17.61 11.1401 17.85 10.8101 17.71C9.60012 17.19 8.0201 16.71 6.9201 16.57L6.7301 16.55C6.1201 16.47 5.62012 15.9 5.62012 15.28V7.57999C5.62012 6.81999 6.24012 6.25 7.00012 6.31C8.25012 6.41 10.1001 7.01001 11.2601 7.67001C11.4101 7.74001 11.5001 7.91 11.5001 8.09Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.38 7.70007V15.2701C18.38 15.89 17.88 16.4601 17.27 16.5401L17.06 16.5601C15.97 16.7101 14.4 17.1801 13.19 17.6901C12.86 17.8301 12.5 17.5901 12.5 17.2301V8.08005C12.5 7.90005 12.59 7.73008 12.75 7.64008C13.91 6.99008 15.72 6.41005 16.95 6.30005H16.99C17.76 6.31005 18.38 6.93007 18.38 7.70007Z",
    fill: "white",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddressBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address-book.1dfb2685774825b7953c4b594a282675.svg";